import Bowser from 'bowser/bundled';

const isMobile = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const platform = browser.parsedResult.platform.type;
  let answer = false;

  if (platform === 'mobile') {
    answer = true;
  }
  return answer;
};

export default isMobile;
